import {input as collapse} from "./collapse";
import {input as expand} from "./expand";
import {input as join} from "./join";
import {input as search} from "./search";
import {input as clear} from "./clear";

export const commands = {
	collapse: collapse,
	expand: expand,
	join: join,
	j: join,
	search: search,
	clear: clear,
};
